import { isNative } from './platform';

let shareModule = null;

async function loadShare() {
  if (shareModule) return shareModule;
  const mod = await import('@capacitor/share');
  shareModule = mod.Share;
  return shareModule;
}

export async function shareOffer({ title, text, url }) {
  if (isNative()) {
    try {
      const Share = await loadShare();
      await Share.share({ title, text, url, dialogTitle: 'Partager cette offre' });
      return true;
    } catch (e) {
      if (e?.message?.toLowerCase?.().includes('cancel')) return false;
      console.warn('Native share failed', e);
      return false;
    }
  }
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return true;
    } catch (e) {
      return false;
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch (e) {
    return false;
  }
}
